export interface Registration {
  email: string
  password: string
  passwordConfirmation: string
}

export class RegistrationModel implements Registration {
  email = ''
  password = ''
  passwordConfirmation = ''
}
